import { StockImportTypeEnum } from './stock-import-type';

export const INVENTORY_WAREHOUSE = 'INVENTORY_WAREHOUSE';
export const STOCK_IMPORT_TYPE = 'IMPORT_STOCK_COUNTS_TYPE';

export const actionMap = {
  [INVENTORY_WAREHOUSE]: (state, { inventoryWarehouse }) => {
    return {
      ...state,
      inventoryWarehouse,
    };
  },
  [STOCK_IMPORT_TYPE]: (state, { stockImportType }) => {
    return {
      ...state,
      stockImportType,
    };
  },
};

export const initialState = {
  inventoryWarehouse: undefined,
  stockImportType: StockImportTypeEnum.Overwrite,
};
